import script from "./VoiceEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./VoiceEditor.vue?vue&type=script&setup=true&lang=js"

import "./VoiceEditor.vue?vue&type=style&index=0&id=39bc8208&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39bc8208"]])

export default __exports__